import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function Names({ id, state, onChange }) {
  function handleChange(event) {
    var inputElement = document.getElementById(event.target.id);
    var errorElement = inputElement.nextSibling;
    if (event.target.id === id + "FirstName") {
      if (event.target.value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The First name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z\\&-]+$/.test(event.target.value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The First name should contain only letters and & \\ - symbols";
        errorElement.style.display = "block";
      } else if (event.target.value.toString().toLowerCase().includes("null")) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = 'The First name can\'t contain "Null" name.';
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }
    if (event.target.id === id + "MiddleName") {
      if (event.target.value.trim().length !== 0) {
        if (!/^[ a-zA-Z\\&-]+$/.test(event.target.value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "The Middle name should contain only letters and & \\ - symbols";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }
    if (event.target.id === id + "LastName") {
      if (event.target.value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Last name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z\\&-]+$/.test(event.target.value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Last name should contain only letters and & \\ - symbols";
        errorElement.style.display = "block";
      } else if (event.target.value.toString().toLowerCase().includes("null")) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = 'The Last name can\'t contain "Null" name.';
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }
    onChange(event);
  }

  return (
    <>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>First Name</strong>
            <br />
            First name of the responsible party. The first, middle, and last name must match exactly as on file with the
            IRS and SSA.
          </Tooltip>
        }
      >
        <Form.Group controlId={id + "FirstName"}>
          <Form.Label>First name</Form.Label>
          <Form.Control
            type="text"
            required
            placeholder="First name"
            pattern="^[ a-zA-Z&\\-]+$"
            maxLength="30"
            onKeyPress={(event) => {
              if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
            }}
            onChange={handleChange}
            data-hj-allow
            defaultValue={state[id + "FirstName"]}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Middle Name</strong>
            <br />
            OPTIONAL: Middle name of responsible party. The name must match exactly as on file with the IRS and SSA.
          </Tooltip>
        }
      >
        <Form.Group controlId={id + "MiddleName"}>
          <Form.Label>Middle name (optional)</Form.Label>
          <Form.Control
            type="text"
            placeholder="Middle name"
            pattern="^[ a-zA-Z&\\-]+$"
            maxLength="30"
            onKeyPress={(event) => {
              if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
            }}
            onChange={handleChange}
            data-hj-allow
            defaultValue={state[id + "MiddleName"]}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Last Name</strong>
            <br />
            The name must match exactly as on file with the IRS and SSA. If this information submitted here does not
            match the IRS records, this will cause delays in the processing of your EIN Application.
          </Tooltip>
        }
      >
        <Form.Group required controlId={id + "LastName"}>
          <Form.Label>Last name</Form.Label>
          <Form.Control
            type="text"
            required
            placeholder="Last name"
            maxLength="30"
            pattern="^[ a-zA-Z&\\-]+$"
            onChange={handleChange}
            onKeyPress={(event) => {
              if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
            }}
            data-hj-allow
            defaultValue={state[id + "LastName"]}
          />
          <Form.Control.Feedback type="invalid">Please provide last name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
    </>
  );
}
